import { Injectable } from '@angular/core';
import { convertChangeNumberToObjectKey, rethrowAsSapError } from 'src/app/lego-utils';
import { uniq } from 'lodash-es';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Eco } from 'src/app/models/domain';
import { EcoAdapter } from 'src/app/models/domain/adapters/eco-adapter';
import {
  YPMDOCUMENTVCDSYpmDocumentVType,
  YpmDocumentVService,
} from 'src/generated-clients/document';

@Injectable({
  providedIn: 'root',
})
export class EcoDataService {
  public constructor(
    private readonly documentService: YpmDocumentVService,
    private readonly ecoAdapter: EcoAdapter
  ) {}

  public loadByChangeNumbers(changeNumbers: string[]): Observable<Eco[]> {
    const objectKeyFilter = uniq(
      changeNumbers.map(
        (changeNumber) => `ObjectKey eq '${convertChangeNumberToObjectKey(changeNumber)}'`
      )
    ).join(' or ');

    const documentObjectPropertyName: keyof YPMDOCUMENTVCDSYpmDocumentVType = 'DocumentObject';
    const documentTypePropertyName: keyof YPMDOCUMENTVCDSYpmDocumentVType = 'DocumentType';

    const filter = `${documentObjectPropertyName} eq 'AENR' and ${documentTypePropertyName} eq 'ECO' and (${objectKeyFilter})`;

    return this.documentService.ypmDocumentVGet(undefined, undefined, filter).pipe(
      rethrowAsSapError(),
      map((res) => {
        if (!res.d?.results) {
          throw new Error('SAP Error');
        }

        return res.d.results.map((ypmDocument) => this.ecoAdapter.adaptToDomain(ypmDocument));
      })
    );
  }
}
